"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    buttonCompoundVariants: ()=>buttonCompoundVariants,
    buttonDefaultVariants: ()=>buttonDefaultVariants,
    buttonDisabledVariants: ()=>buttonDisabledVariants,
    buttonDropShadowVariants: ()=>buttonDropShadowVariants,
    buttonEmphases: ()=>buttonEmphases,
    buttonEmphasisVariants: ()=>buttonEmphasisVariants,
    buttonFullWidthVariants: ()=>buttonFullWidthVariants,
    buttonShadowVariants: ()=>buttonShadowVariants,
    buttonShadows: ()=>buttonShadows,
    buttonSizeVariants: ()=>buttonSizeVariants,
    buttonSizes: ()=>buttonSizes,
    buttonSlots: ()=>buttonSlots,
    buttonTypeVariants: ()=>buttonTypeVariants,
    buttonTypes: ()=>buttonTypes
});
const buttonTypeVariants = {
    primary: {},
    secondary: {},
    tertiary: {},
    primaryShop: {},
    critical: {}
};
const buttonTypes = Object.keys(buttonTypeVariants);
const buttonSizeVariants = {
    sm: {
        buttonSlot: 'min-h-8 px-2 py-1 rounded-action-sm gap-x-1',
        textSlot: 'text-action2'
    },
    md: {
        buttonSlot: 'min-h-10 px-3 py-2 rounded-action-md gap-x-1',
        textSlot: 'text-action2'
    },
    lg: {
        buttonSlot: 'px-4 py-3 rounded-action-lg gap-x-1.5',
        textSlot: 'text-action1'
    },
    xl: {
        buttonSlot: 'p-4 rounded-action-xl gap-x-1.5',
        textSlot: 'text-action1'
    }
};
const buttonSizes = Object.keys(buttonSizeVariants);
const buttonEmphasisVariants = {
    regular: '',
    medium: '',
    bold: ''
};
const buttonEmphases = Object.keys(buttonEmphasisVariants);
const buttonSlots = {
    buttonSlot: 'align-center antialiased align-middle focus-visible:ring-actionSecondary-12 flex cursor-pointer flex-row items-center justify-center transition-* focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
    textSlot: 'px-1 font-bold transition',
    iconSlot: 'transition'
};
const buttonFullWidthVariants = {
    true: {
        buttonSlot: 'w-full'
    }
};
const buttonShadowVariants = {
    true: {
        buttonSlot: 'shadow-md hover:shadow-xl'
    }
};
const buttonShadows = Object.keys(buttonShadowVariants);
const buttonDropShadowVariants = {
    true: {
        buttonSlot: 'drop-shadow-md hover:drop-shadow-xl'
    }
};
const buttonDisabledVariants = {
    true: {
        buttonSlot: 'cursor-not-allowed shadow-none'
    }
};
const buttonCompoundVariants = [
    {
        emphasis: 'regular',
        type: 'primary',
        class: {
            buttonSlot: 'bg-actionPrimary-8 hover:bg-actionPrimary-9 text-actionPrimary-3 hover:text-actionPrimary-4'
        }
    },
    {
        emphasis: 'regular',
        type: 'secondary',
        class: {
            buttonSlot: 'bg-actionSecondary-8 hover:bg-actionSecondary-9 text-actionSecondary-3 hover:text-actionSecondary-4'
        }
    },
    {
        emphasis: 'regular',
        type: 'tertiary',
        class: {
            buttonSlot: 'hover:bg-actionSecondary-9 text-actionSecondary-3 hover:text-actionSecondary-4'
        }
    },
    {
        emphasis: 'regular',
        type: 'primaryShop',
        class: {
            buttonSlot: 'bg-actionShop-8 hover:bg-actionShop-9 text-actionShop-3 hover:text-actionShop-4'
        }
    },
    {
        emphasis: 'regular',
        type: 'critical',
        class: {
            buttonSlot: 'bg-actionCritical-8 hover:bg-actionCritical-9 text-actionCritical-3 hover:text-actionCritical-4'
        }
    },
    {
        emphasis: 'regular',
        disabled: true,
        class: {
            buttonSlot: 'bg-actionSecondary-2 hover:bg-actionSecondary-2 text-actionSecondary-6 hover:text-actionSecondary-6'
        }
    },
    {
        emphasis: 'medium',
        type: 'primary',
        class: {
            buttonSlot: 'bg-actionPrimary-8 hover:bg-actionPrimary-9 text-actionPrimary-3 hover:text-actionPrimary-4'
        }
    },
    {
        emphasis: 'medium',
        type: 'secondary',
        class: {
            buttonSlot: 'bg-actionSecondary-1/80 hover:bg-actionSecondary-1 text-actionSecondary-3 hover:text-actionSecondary-4'
        }
    },
    {
        emphasis: 'medium',
        type: 'tertiary',
        class: {
            buttonSlot: 'hover:bg-actionSecondary-1/80 text-actionSecondary-3 hover:text-actionSecondary-4'
        }
    },
    {
        emphasis: 'medium',
        type: 'primaryShop',
        class: {
            buttonSlot: 'bg-actionShop-8 hover:bg-actionShop-9 text-actionShop-3 hover:text-actionShop-4'
        }
    },
    {
        emphasis: 'medium',
        type: 'critical',
        class: {
            buttonSlot: 'bg-actionCritical-8 hover:bg-actionCritical-9 text-actionCritical-3 hover:text-actionCritical-4'
        }
    },
    {
        emphasis: 'medium',
        disabled: true,
        class: {
            buttonSlot: 'bg-actionSecondary-1/60 hover:bg-actionSecondary-1/60 text-actionSecondary-6 hover:text-actionSecondary-6'
        }
    },
    {
        emphasis: 'bold',
        type: 'primary',
        class: {
            buttonSlot: 'bg-actionPrimary-3 hover:bg-actionPrimary-4 focus-visible:ring-actionPrimary-1 focus-visible:ring-offset-actionPrimary-12 text-actionPrimary-8 hover:text-actionPrimary-9'
        }
    },
    {
        emphasis: 'bold',
        type: 'secondary',
        class: {
            buttonSlot: 'bg-actionSecondary-8/20 hover:bg-actionSecondary-9/40 text-actionSecondary-1 hover:text-actionSecondary-2'
        }
    },
    {
        emphasis: 'bold',
        type: 'tertiary',
        class: {
            buttonSlot: 'ring-actionSecondary-12 hover:bg-actionSecondary-8/20 text-actionSecondary-1 hover:text-actionSecondary-2'
        }
    },
    {
        emphasis: 'bold',
        type: 'primaryShop',
        class: {
            buttonSlot: 'bg-actionShop-3 hover:bg-actionShop-4 text-actionShop-8 hover:text-actionShop-9 focus-visible:ring-actionPrimary-1 focus-visible:ring-offset-actionPrimary-12'
        }
    },
    {
        emphasis: 'bold',
        type: 'critical',
        class: {
            buttonSlot: 'bg-actionCritical-3 hover:bg-actionCritical-4 text-actionCritical-8 hover:text-actionCritical-9 focus-visible:ring-actionPrimary-1 focus-visible:ring-offset-actionPrimary-12'
        }
    },
    {
        emphasis: 'bold',
        disabled: true,
        class: {
            buttonSlot: 'bg-actionPrimary-2/20 hover:bg-actionPrimary-2/20 text-actionPrimary-6/40 hover:text-actionPrimary-6/40'
        }
    }
];
const buttonDefaultVariants = {
    emphasis: 'regular',
    type: 'secondary',
    size: 'md'
};
exports.buttonCompoundVariants = __webpack_exports__.buttonCompoundVariants;
exports.buttonDefaultVariants = __webpack_exports__.buttonDefaultVariants;
exports.buttonDisabledVariants = __webpack_exports__.buttonDisabledVariants;
exports.buttonDropShadowVariants = __webpack_exports__.buttonDropShadowVariants;
exports.buttonEmphases = __webpack_exports__.buttonEmphases;
exports.buttonEmphasisVariants = __webpack_exports__.buttonEmphasisVariants;
exports.buttonFullWidthVariants = __webpack_exports__.buttonFullWidthVariants;
exports.buttonShadowVariants = __webpack_exports__.buttonShadowVariants;
exports.buttonShadows = __webpack_exports__.buttonShadows;
exports.buttonSizeVariants = __webpack_exports__.buttonSizeVariants;
exports.buttonSizes = __webpack_exports__.buttonSizes;
exports.buttonSlots = __webpack_exports__.buttonSlots;
exports.buttonTypeVariants = __webpack_exports__.buttonTypeVariants;
exports.buttonTypes = __webpack_exports__.buttonTypes;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "buttonCompoundVariants",
    "buttonDefaultVariants",
    "buttonDisabledVariants",
    "buttonDropShadowVariants",
    "buttonEmphases",
    "buttonEmphasisVariants",
    "buttonFullWidthVariants",
    "buttonShadowVariants",
    "buttonShadows",
    "buttonSizeVariants",
    "buttonSizes",
    "buttonSlots",
    "buttonTypeVariants",
    "buttonTypes"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
